var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-dashboard-panel"},[(_vm.user.isOrganizer)?_c('OrganizationEdit',{attrs:{"org-id":_vm.org.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }